import React from "react";
import StatusEmployeePage from "../StatusEmployee/views/StatusEmployeePage"
import { StatusEmployeeContextProvider } from "./StatusEmployeeView";
import StatusContents from "../../constants/contentFile.json";

const StatusEmployeeView = () => {
  return (
    <StatusEmployeeContextProvider>
      <StatusEmployeePage textContents={StatusContents.status} />
    </StatusEmployeeContextProvider>
  );
};
export default StatusEmployeeView;